import type {
  RefundSessionApiQuery,
  SessionsApi,
  SessionApiQuery,
  SessionCreateApiQuery,
  SessionType,
} from "@/Modules/Models/Api/Sessions";
import type { CanMarkSessionsApi } from "@/Modules/Models/Api/Sessions";

import TherapySideApiService from "./utils/TherapyApi";

class SessionsApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getSessions(customerUuid: string): Promise<SessionsApi> {
    return this.ApiService.get<SessionApiQuery, SessionsApi>({
      endpoint: "v1.0/subscriptions/sessions",
      params: {
        user_uuid: customerUuid,
      },
    });
  }

  createSessions(
    userUuid: string,
    attendedAt: number,
    sessionType: SessionType,
    reasonUuid?: string,
    comment?: string
  ): Promise<void> {
    return this.ApiService.post<SessionCreateApiQuery, void>({
      endpoint: "v1.0/subscriptions/sessions",
      body: {
        user_uuid: userUuid,
        attended_at: attendedAt,
        type: sessionType,
        reason: reasonUuid,
        comment: comment,
      },
    });
  }

  refundSessions(customerUuid: string, sessionData: RefundSessionApiQuery): Promise<void> {
    return this.ApiService.post<RefundSessionApiQuery, void>({
      endpoint: `v2.0/subscriptions/sessions/${customerUuid}/refund`,
      body: sessionData,
    });
  }

  deleteSessions(sessionUuid: string): Promise<void> {
    return this.ApiService.delete<void, void>({
      endpoint: `v1.0/subscriptions/sessions/${sessionUuid}`,
    });
  }

  checkIsSessionRegister(customerUuid: string): Promise<CanMarkSessionsApi> {
    return this.ApiService.get<void, CanMarkSessionsApi>({
      endpoint: `v1.0/subscriptions/sessions/${customerUuid}/check`,
    });
  }
}

export default SessionsApiConnector;
